import { ANONYMOUS_USER_NAME, UserStatus, IUserInfo } from "types";

export const userIsActive = (userInfo: IUserInfo): boolean => {
  return !userInfo?.status || userInfo?.status === UserStatus.Active || userInfo?.status === UserStatus.Provisioned;
};

export const canOpenProfile = (userInfo: IUserInfo, authUserId: string | undefined | null): boolean => {
  if (!userInfo || !authUserId || userInfo.isGuest) {
    return false;
  }
  return (
    (userInfo?.id ?? userInfo?.userId) !== authUserId &&
    !userInfo?.isAnonymous &&
    ((userInfo?.firstName || "") + " " + (userInfo?.lastName || "")).trim() !== ANONYMOUS_USER_NAME &&
    userIsActive(userInfo)
  );
};

export const userName = (userInfo?: IUserInfo | null, emailAsFallback = false): string => {
  if (!userInfo) {
    return "";
  }

  const firstLastName = userInfo.firstName ? `${userInfo.firstName} ${userInfo.lastName}` : "";

  const bookingIsAnonymous = userInfo.isAnonymous;
  const bookingHasUserNameInfo = userInfo.firstName && userInfo.lastName;
  const shouldShowAnonymousUser = firstLastName === ANONYMOUS_USER_NAME || (!userInfo.firstName && !userInfo.lastName); // some endpoints return anonymous user as "Anonymous user" but some  return empty user :(

  // In case the booking is anonymous, but the user that is requesting the info is admin, we still want to show the user itself (and in that case we get the user name from the BE)
  const userName =
    bookingIsAnonymous && shouldShowAnonymousUser
      ? $localize`:@@common|anonymous-user:Anonymous user`
      : bookingHasUserNameInfo
        ? firstLastName
        : $localize`:@@common|unknown-user:Unknown user`;
  const userNameWithEmailAsFallback = emailAsFallback && !userName.length ? userInfo.email || "" : userName;

  return userInfo.isGuest
    ? `${userNameWithEmailAsFallback} ${$localize`:@@common|guest-with-brackets:(Guest)`}`
    : userNameWithEmailAsFallback;
};
